import React from 'react';
import "./styles.css";
// import { useState } from 'react';
import Page from './component/Page'
// import Practice from './component/Practice';
// import Modal from './component/Modal';
// import Modaal from './component/Modaal';

export default function App() {
  return (
    <Page />
    // <Practice />
  )
}